import { render, staticRenderFns } from "./DetalheProcesso.vue?vue&type=template&id=4b83206f&"
import script from "./DetalheProcesso.vue?vue&type=script&lang=js&"
export * from "./DetalheProcesso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports